import { AccountPlusIcon } from './AccountPlusIcon';

/**
 * author: Google
 * id 66556BA4-6B65-4ED9-B813-AD33CA8C2CCF
 * name account-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-plus.svg
 * tags
 * - Account / User 
 * - Home Automation 
 */
export const UserPlusIcon = AccountPlusIcon;
export default UserPlusIcon